// extracted by mini-css-extract-plugin
export default {"image":"ImageObject_image__jO64e"};